import { CHANNEL_ID, FILE_ID } from '@@types/common';

import { URLS } from '~/constants';
import { channelsStore } from '~/stores/ChannelsStore';
import { makeDownloadUrl } from '~/utils/fileLogUtil';
import { getUrlByEnv, isWinNative } from '~/utils/runEnvironmentUtil';
import { assign, get, map } from 'lodash';

const defaultPopupOption = { width: 1024, height: 800 };

const _createPopupOptions = (options) => map(options, (val, key) => `${key}=${val}`).join(',');

const open = (url: string, target: string = '_blank', options?: any) => {
  return window.open(url, target, _createPopupOptions(assign({}, defaultPopupOption, options)));
};

const openGravatarEdit = () => {
  open('http://gravatar.com/site/signup', '_blank', { width: 1024, height: 800 });
};

const CALLER = 'caller=messenger';

const openDoorayFeaturePopup = (type: string, membersMail: string[], title = '') => {
  if (type === 'calendar') {
    openCalendar(membersMail, title);
  } else if (type === 'mail') {
    openMail(membersMail, title);
  } else if (type === 'task') {
    openTask(membersMail, title);
  } else if (type === 'form') {
    openForm();
  } else {
    open(`/popup/${type}/write/new?to=${membersMail.join('&to=')}&subject=${title}&messenger&${CALLER}`);
  }
};

const openTask = (membersMail, title = '') => {
  open(`${getUrlByEnv('TASK_WRITE')}?to=${membersMail.join('&to=')}&subject=${title}&messenger&${CALLER}`);
};

const openTaskDraft = (draftId: string) => {
  open(`${URLS.TASK_DRAFT_WRITE}${draftId}`);
};

const openTaskView = (taskId: string) => {
  window.open(`${URLS.TASK_VIEW}${taskId}`, '_blank');
};

const openCalendar = (membersMail, title = '') => {
  open(`${getUrlByEnv('CALENDAR_WRITE')}?to=${membersMail.join(',')}&subject=${title}&messenger&${CALLER}`, '_blank', {
    width: 1280,
  });
};

const openMail = (membersMail, title = '') => {
  open(`/mail/write/new?to=${membersMail.join('&to=')}&subject=${title}&messenger&${CALLER}`);
};

const openForm = () => {
  open('/form', '_blank', { width: 1280 });
};

const openOriginalEml = (fileId) => {
  open(`/preview-pages/messenger/${fileId}?hideTitle=true`, 'messenger:eml');
};

const openMeeting = (meetingUrl: string, email: string, name: string, token: string) => {
  window.open(
    `${meetingUrl}?id=${email}&name=${window.encodeURIComponent(
      name
    )}&email=${email}&integrationname=nhn&token=${token}`,
    '_blank'
  );
};

const openWebex = (webexUrl: string) => {
  window.open(webexUrl, '_blank');
};

export const openOriginalImagePopup = (image, isShared) => {
  const imgWidth = get(image, 'thumbsJson.original.width', 1280);
  const imgHeight = get(image, 'thumbsJson.original.height', 1024);
  const width = Math.max(320, Math.min(imgWidth, window.screen.availWidth));
  const height = Math.max(240, Math.min(imgHeight + 1, window.screen.availHeight));
  const url = `/messenger/image/${image.channelId}/${image.id}?w=${width}&h=${height}${isShared ? '&share=true' : ''}`;
  open(url, '_blank', { width, height });
};

export const restoreWindowRef = (windowName) => {
  return isWinNative() ? open('', windowName, { width: 0, height: 0 }) : open('', windowName);
};

const openTrelloAuthrizePopup = () => {
  return open(
    `https://trello.com/1/authorize?response_type=token&key=dcac84559be3596392b79eaa9ba88694&return_url=${window.location.origin}&callback_method=postMessage&scope=read&expiration=never&name=`,
    '_blank'
  );
};

const openPreviewPagePopup = (channelId: CHANNEL_ID, fileId: FILE_ID) => {
  return open(`/preview-pages/messenger/${channelId}-${fileId}?hideNav=true`, '_blank');
};

const openVideoPreviewPopup = (channelId: CHANNEL_ID, id: FILE_ID) => {
  const isSharedChannel = channelsStore.isSharedChannelId(channelId);
  const videoUrl = makeDownloadUrl({ channelId, id }, isSharedChannel);

  return open(`${videoUrl}?type=inline`, '_blank');
};

const popupWindowService = {
  open,
  openCalendar,
  openMail,
  openGravatarEdit,
  openTask,
  openTaskDraft,
  openTaskView,
  openMeeting,
  openWebex,
  openOriginalImagePopup,
  openOriginalEml,
  openDoorayFeaturePopup,
  restoreWindowRef,
  openTrelloAuthrizePopup,
  openPreviewPagePopup,
  openVideoPreviewPopup,
};
export default popupWindowService;
